import { ParsedUrlQuery } from "querystring";
import { useSDK } from "~hooks";
import { Order } from "~graphql/sdk";
import { useEffect } from "react";

const KeySeparator = "!";

const BroadcastReportingData = "BroadcastReportingData";

const getReportingData = () => {
  const dataString = localStorage?.getItem(BroadcastReportingData);
  if (dataString) {
    return JSON.parse(dataString) as string[];
  }
  return [];
};
const setReportingData = (data: string[] = []) => {
  localStorage?.setItem(BroadcastReportingData, JSON.stringify(data));
};
export const useCampaignReportingOpen = async (query: ParsedUrlQuery) => {
  const reportingId = (query?.["campaign-id"] ?? "") as string;
  const [broadcastId, userId, eventId] = reportingId.split(KeySeparator);
  if (broadcastId && userId && eventId) {
    useRemoveCampaignCacheOnWindowClose(reportingId);
    const data = getReportingData();
    if (!data.includes(reportingId)) {
      const sdk = useSDK();
      await sdk.broadcastReportingLinkOpened({
        input: {
          broadcastId,
          eventId,
          userId,
        },
      });
      const newData = [...data, reportingId];
      setReportingData(newData);
    }
  }
};

export const useCampaignReportingForOrder = async (order: Order) => {
  const data = getReportingData();
  const reportingId = data.find((reportingId) => {
    const [, , eventId] = reportingId.split(KeySeparator);
    return order.event.id == eventId;
  });
  if (reportingId) {
    const [broadcastId, userId, eventId] = reportingId.split(KeySeparator);
    const sdk = useSDK();
    await sdk.broadcastReportingOrderCreated({
      input: {
        broadcastId,
        eventId,
        userId,
        orderId: order.id,
      },
    });
  }
};

// todo clarify below
//  this method will clear the campaign tracking id when the user is passed off to the PSP.
//  So we will need to either persist this and track all orders for the event based on the tracking context
//  or apply the tracking campaign id to the return url.
export const useRemoveCampaignCacheOnWindowClose = (key: string) => {
  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      // delete the reporting data for this campaign-id when the browser is closed.
      const data = getReportingData();
      setReportingData(data.filter((id) => id != key));
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
  }, [typeof window]);
};
